import React from "react";
import { useT } from "../../i18n";

const Main: React.FC = () => {
  const t = useT();
  return (
  <div className="flex-1 flex flex-col items-center justify-center h-full">
    <h1 className="text-4xl font-bold text-blue-600 mb-4">{t("main.title")}</h1>
    <p className="text-lg text-gray-700">
      {t("main.subtitle")}
    </p>
  </div>
  );
};

export default Main;
